export default __webpack_public_path__ + "static/media/ddsu5168_2p_wireless_4g.b2b553a9.png";